import React from "react"
import PropTypes from "prop-types"
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import CreditCardElement from './CreditCardElement'
import LoaderSection from '../../app_components/LoaderSection'


class OneTimeCheckout extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      sessionId: '',
      loaded: false,
    }

    this.handleClick = this.handleClick.bind(this)
    this.createSession = this.createSession.bind(this)
    this.setDescription = this.setDescription.bind(this)
  }


  async handleClick() {
    // Get Stripe.js instance
    const stripePromise = loadStripe(this.props.stripePublishableKey)

    const stripe = await stripePromise;

    // redirect to Checkout.
    const result = await stripe.redirectToCheckout({
      sessionId: this.state.sessionId,
    });

    if (result.error) {
      // If `redirectToCheckout` fails due to a browser or network
      // error, display the localized error message to your customer
      // using `result.error.message`.
    }
  };

  setDescription() {
    switch (this.props.item_id) {
      case 1:
        this.setState({
          item_id: this.props.item_id,
          description: 'Identity Verification',
          price: 1000
        })
        break;
      case 2:
        this.setState({
          item_id: this.props.item_id,
          description: '1 Lexicoin',
          price: 100
        })
        break;
      case 3:
        this.setState({
          item_id: this.props.item_id,
          description: '10 Lexicoins',
          price: 800
        })
        break;
      default:

    }
  }

  createSession() {
    $.ajax({
      url: `../createCheckoutSession`,
      dataType: 'JSON',
      type: 'POST',
      header: {
        'Content-Type': 'application/json'
      },
      data: {
        item_id: this.state.item_id,
        description: this.state.description,
        price: this.state.price
      },
      success: (data) => {
        this.setState({
          sessionId: data.session_id,
          loaded: true
        }, () => this.handleClick())
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }


  async componentDidMount() {
    await this.setDescription()
    await this.createSession()
  }

  render() {
    return (
      <LoaderSection />
    )
  }
};

export default OneTimeCheckout;
